// extracted by mini-css-extract-plugin
export default {"tabs":"main_tabs__poeAh"};